'use client';
import YouTube from 'react-youtube';

export default function YouTubeVideo({ videoId }) {
    const opts = {
        height: '360',
        width: '640',
        playerVars: {
            autoplay: 1, // 自动播放视频
        },
    };

    const onReady = (event) => {
        event.target.pauseVideo();
    };

    return <YouTube className={`ytb`} videoId={videoId} opts={opts} />;
}
